import { AppState } from './types';

export default {
  setApplicationId(state: AppState, applicationId: string) {
    state.applicationId = applicationId;
  }
};
